import {Preview, template as tpl} from "./Preview";
import clientcredentialHtml from './clientcredential.html?raw';

export let template = tpl.replace('<!-- {{TEMPLATE_ROW}} -->', clientcredentialHtml);

export class viewModel extends Preview {

    constructor(params: any) {
        super(params);
        this.table = [
            {key: 'id', sort: false},
            {key: 'Name', sort: true},
            {key: 'Description', sort: true},
            {key: 'ExpiryDate', sort: true},
        ];
        this.searchcolumn('Name');
        this.showAll(true);
    }

}
